import React from "react";
export default (props) => {
  return <div className="flex flex-col space-y-3">
    <label className="text-gray-500" htmlFor={props.name}>{props.label} {props.required ? <i className="star ">*</i> : ''}</label>
    <input type="file" name={props.name} id={props.name} className="block w-full border border-gray-200 shadow-sm rounded-lg text-sm focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none
    file:bg-gray-50 file:border-0
    file:me-4
    file:py-3 file:px-4" />
    {props.value && <img className="w-64" src={props.value} />}
  </div>
}